import { QueryCache, QueryClient } from "@tanstack/react-query";

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Mutations invalidate the keys they touch, and entity lists and
        // dashboards get pushed updates over the subscription websocket, so
        // remounting a screen within two minutes does not need a fresh fetch.
        staleTime: 2 * 60 * 1000,
        gcTime: 10 * 60 * 1000, // 10 minutes - keep inactive data in cache
        refetchOnWindowFocus: false,
      },
    },
    queryCache: new QueryCache({
      onError: () => {
        // if (error instanceof ClientError) {
        //   if (error?.response?.status === 401) {
        //     console.error('providers: unauthorized, deleting auth cookies');
        //   }
        // }
      },
    }),
  });
}
